import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import * as References from 'video-data-lib/__generated__/chirp/com/hubspot/video/rpc/HubSpotVideoRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});
export const fetchVideoByFileId = fileId => {
  return chirpClient.call(References.getVideoByFileIdRpc, {
    request: {
      sourceFileId: fileId
    }
  });
};
export const fetchVideoByVideoId = videoId => {
  return chirpClient.call(References.getVideoByVideoIdRpc, {
    request: {
      videoId
    }
  });
};